import React from "react";

import styles from "../../styles/select-active-unit.module.scss";

import { Drawer } from "../components/Drawer";
import { Button } from "../components/Button";
import { Label } from "../components/Label";
import { InputSearch } from "../components/InputSearch";
import { Radio } from "../components/Radio";
import { EnvironmentStorage } from "../tools/EnvironmentStorage";
import { EnvironmentsAPI } from "../../providers/EnvironmentsAPI";
import { UserStorage } from "../tools/UserStorage";
import { Icon } from "../components/core/Icon";
import { Link } from "react-router-dom";
import ROLES from "data/Roles";
import { If } from "shared/components/control-statements";

export class SelectActiveUnit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      environment: {},
      units: [],
      brands: [],
      brandSearchTerm: null,
      unitSearchTerm: null,
      currrentAvatar: null,
    };
  }

  async componentDidMount() {
    const user = UserStorage.getLoggedUser();
    const unitsResponse = await EnvironmentsAPI.getAvailableUnits(
      user.environment_id
    );
    const units = unitsResponse.getData([]);
    const brands = Object.values(
      units.reduce((a, u) => ({ ...a, [u.brand.id]: u.brand }), {})
    );
    this.setState({
      environment: EnvironmentStorage.getEnvironment(),
      currrentAvatar: EnvironmentStorage.getCurrentAvatar(),
      units: units,
      brands: brands,
    });
  }

  async componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      const user = UserStorage.getLoggedUser();
      const unitsResponse = await EnvironmentsAPI.getAvailableUnits(
        user.environment_id
      );
      const units = unitsResponse.getData([]);
      const brands = Object.values(
        units.reduce((a, u) => ({ ...a, [u.brand.id]: u.brand }), {})
      );
      this.setState({
        environment: EnvironmentStorage.getEnvironment(),
        currrentAvatar: EnvironmentStorage.getCurrentAvatar(),
        units: units,
        brands: brands,
      });
    }
  }

  async setSelectedUnit() {
    const { onClose, tempPath } = this.props;
    const { selectedUnit } = this.state;

    EnvironmentStorage.setSelectedEnvironment(selectedUnit.id);
    EnvironmentStorage.setEnvironment(selectedUnit);

    if (selectedUnit.alias) {
      EnvironmentStorage.setConfigurations(
        await EnvironmentsAPI.getS3Configurations(selectedUnit.alias)
      );
      await EnvironmentStorage.getEnvironmentExtraMenus();
    }

    onClose && onClose(true);
    window.location = tempPath || window.location;
  }

  async setSelectedBrand() {
    const { onClose } = this.props;
    const { selectedBrand } = this.state;

    EnvironmentStorage.setSelectedEnvironment(selectedBrand.id);
    EnvironmentStorage.setEnvironment({
      ...selectedBrand,
      type: "BRAND",
    });

    if (selectedBrand.alias) {
      EnvironmentStorage.setConfigurations(
        await EnvironmentsAPI.getS3Configurations(selectedBrand.alias)
      );
    }

    onClose && onClose(true);
    window.location = window.location;
  }

  render() {
    const {
      step,
      selectedBrand,
      selectedUnit,
      environment,
      units,
      brands,
      brandSearchTerm,
      unitSearchTerm,
      currrentAvatar,
    } = this.state;
    const { visible, onClose, direction } = this.props;

    const nextStep = () => {
      this.setState({ step: step + 1 });
    };

    const filteredBrands = brands.filter((b) =>
      !!brandSearchTerm
        ? b.name.toLowerCase().indexOf(brandSearchTerm.toLowerCase()) > -1
        : true
    );
    const filteredUnits = units.filter((u) => {
      if (!(selectedBrand && selectedBrand.id)) {
        return false;
      }

      return (
        (!!unitSearchTerm
          ? u.name.toLowerCase().indexOf(unitSearchTerm.toLowerCase()) > -1
          : true) && selectedBrand.id == u.brand.id
      );
    });

    const showBrands = () => {
      const userData = UserStorage.getLoggedUser();
      return userData?.user_type !== "UNIT";
    };

    let userRole = UserStorage.getLoggedUser()?.role;

    const env = EnvironmentStorage.getEnvironment();
    const isUnitSelected = env?.type !== "BRAND" && env?.type !== "HOLDING";

    return (
      <Drawer
        visible={visible}
        onClose={() => onClose && onClose(false)}
        title="Seletor de unidade ativa"
        direction={direction}
        showCloseButton={false}
        showBackButton={true}
        backButton={() => {
          if (step === 1) return onClose();
          this.setState({ step: step - 1 });
        }}
      >
        {step === 1 && (
          <div className={styles.activeUnit}>
            <div className="d-flex align-center">
              <div className={styles.logo}>
                <If cond={env?.brand?.avatarUrl}>
                  <img
                    src={
                      process.env.REACT_APP_ASSETS_URL +
                      `/` +
                      env?.brand?.avatarUrl
                    }
                    alt={env?.name}
                  />
                </If>
              </div>
              <div className="d-flex flex-column">
                <p className={styles.brand}>
                  {isUnitSelected ? env?.brand?.name : env?.name}
                </p>
                <If cond={isUnitSelected}>
                  <p className={styles.unit}>{env?.name}</p>
                </If>
              </div>
            </div>

            <div className={styles.hairline} />

            <Button design="primary" onClick={nextStep} className="w-100">
              Trocar unidade ativa
            </Button>
          </div>
        )}

        {step === 2 && (
          <>
            <div className={styles.scrollContainer}>
              <Label>Informe a marca</Label>
              <InputSearch
                placeholder="Buscar por"
                occurrences={filteredBrands.length}
                className="mb-20"
                design="two"
                onChange={(e) =>
                  this.setState({ brandSearchTerm: e.target.value })
                }
              />
              {filteredBrands.map((b) => {
                return (
                  <Radio
                    className="mb-10"
                    family="brand"
                    checked={selectedBrand && selectedBrand.id}
                    value={b.id}
                    onChange={() => this.setState({ selectedBrand: b })}
                  >
                    {b.name}
                  </Radio>
                );
              })}
            </div>

            <div className={styles.footer}>
              <div className="w-100">
                <Button
                  design="primary"
                  className="w-100"
                  disabled={!selectedBrand}
                  onClick={nextStep}
                >
                  Selecionar unidade
                </Button>
                <Button
                  className="w-100 mt-10"
                  disabled={!selectedBrand}
                  onClick={this.setSelectedBrand.bind(this)}
                >
                  Selecionar marca
                </Button>
              </div>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <div className={styles.scrollContainer}>
              <Label>Informe a unidade</Label>
              <InputSearch
                placeholder="Buscar por"
                occurrences={filteredUnits.length}
                className="mb-20"
                design="two"
                onChange={(e) =>
                  this.setState({ unitSearchTerm: e.target.value })
                }
              />
              {filteredUnits.map((u) => {
                return (
                  <Radio
                    className="mb-10"
                    family="unit"
                    checked={selectedUnit && selectedUnit.id}
                    value={u.id}
                    onChange={() => this.setState({ selectedUnit: u })}
                  >
                    {u.name} {!u.active && `(Inativa)`}
                  </Radio>
                );
              })}
            </div>
            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                disabled={!selectedUnit}
                onClick={this.setSelectedUnit.bind(this)}
              >
                Aplicar
              </Button>
            </div>
          </>
        )}

        {showBrands() && step === 1 && (
          <Link to="/configuracoes/marcas">
            <div className={styles.setting} onClick={() => onClose(false)}>
              <div className={styles.icon}>
                <i className="fal fa-store" />
              </div>
              <p>Marcas e unidades</p>
            </div>
          </Link>
        )}
      </Drawer>
    );
  }
}
